export const graniteCategories = [
  {
    id: 1,
    name: "Kitchen Countertops",
    description:
      "Premium granite slabs for kitchen countertops with heat resistance and stunning natural patterns.",
    keyCharacteristics: [
      "Heat resistant surface",
      "Natural stone patterns",
      "Scratch resistant",
      "Food safe finish",
    ],
    commonMaterials: [
      "Natural granite",
      "Polished finish",
      "Sealed surface",
      "Edge treatments",
    ],
    primaryUse: [
      "Kitchen countertops",
      "Island surfaces",
      "Bar tops",
      "Prep areas",
      "Commercial kitchens",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1590736969955-71cc94901144?w=800&h=600&fit=crop",
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["Polished", "Honed", "Leathered", "Flamed"],
    warranty: "25 years on natural stone, 10 years on installation",
    specifications: {
      material: "Natural granite with sealed finish",
      sizes: [
        "Standard slabs 280x175cm",
        "Custom cutting available",
        "Various thicknesses",
      ],
      finish: ["Polished", "Honed", "Leathered", "Flamed"],
      functionality: "Heat and scratch resistant surface",
      installation: "Professional templating and installation",
      maintenance: "Annual sealing, daily cleaning with stone cleaner",
    },
    useCases: [
      {
        location: "Modern Kitchen",
        recommendation: "Large format granite with waterfall edge for island",
        keyChecks: [
          "Cabinet support structure",
          "Seam placement planning",
          "Edge detail preferences",
        ],
      },
      {
        location: "Traditional Kitchen",
        recommendation: "Classic granite patterns with ogee edge treatment",
        keyChecks: [
          "Color coordination",
          "Cabinet style matching",
          "Backsplash integration",
        ],
      },
    ],
  },
  {
    id: 2,
    name: "Bathroom Vanities",
    description:
      "Luxury granite surfaces for bathroom vanities with water resistance and elegant appearance.",
    keyCharacteristics: [
      "Water resistant",
      "Stain resistant",
      "Easy to clean",
      "Luxury appearance",
    ],
    commonMaterials: [
      "Premium granite",
      "Sealed finish",
      "Polished edges",
      "Integrated sinks",
    ],
    primaryUse: [
      "Bathroom vanities",
      "Powder room tops",
      "Master bath suites",
      "Hotel bathrooms",
      "Spa counters",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1590736969955-71cc94901144?w=800&h=600&fit=crop",
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["Polished", "Honed", "Brushed", "Textured"],
    warranty: "25 years on stone, 5 years on sealing",
    specifications: {
      material: "Natural granite with water-resistant sealing",
      sizes: [
        "Standard vanity sizes",
        "Custom dimensions",
        "Integrated sink options",
      ],
      finish: ["Polished", "Honed", "Brushed", "Textured"],
      functionality: "Water and stain resistant with easy maintenance",
      installation: "Professional measurement and installation",
      maintenance: "Regular sealing, gentle cleaning products",
    },
    useCases: [
      {
        location: "Master Bathroom",
        recommendation:
          "Double vanity with matching granite and integrated sinks",
        keyChecks: [
          "Plumbing configuration",
          "Mirror coordination",
          "Lighting integration",
        ],
      },
      {
        location: "Guest Bathroom",
        recommendation: "Single vanity with elegant granite pattern",
        keyChecks: [
          "Space proportions",
          "Color selection",
          "Maintenance requirements",
        ],
      },
    ],
  },
];
